import { synapse } from 'state'
import { BASE_URL } from 'config'

export const getScheduledScenarios = async (params) => {
  try {
    let url = `${BASE_URL}/scheduler/scenario-schedules`

    if (params) url += `?${params}`

    const scenarios = await synapse.fetch(url)
    return scenarios
  } catch (error) {
    console.error(error)
    return null
  }
}

export const insertScheduled = async (body) => {
  try {
    return await synapse.fetch(
      `${BASE_URL}/scheduler/scenario-schedules`,
      {
        method: 'POST'
      },
      body
    )
  } catch (error) {
    console.error(error)
  }
}

export const editScheduled = async (body, id) => {
  return await synapse.fetch(
    `${BASE_URL}/scheduler/scenario-schedules/${id}`,
    {
      method: 'PUT'
    },
    body
  )
}

export const simulateScheduled = async (body, id) => {
  return await synapse.fetch(
    `${BASE_URL}/scheduler/scenario-schedules/${id}/simulate`,
    {
      method: 'POST'
    },
    body
  )
}

export const deleteScheduled = async (params) => {
  return await synapse.fetch(
    `${BASE_URL}/scheduler/scenario-schedules/${params.id}`,
    {
      method: 'DELETE'
    }
  )
}

export const deleteMultipleScheduled = async (params) => {
  return await synapse.fetch(
    `${BASE_URL}/scheduler/scenario-schedules?ids=${params.ids.join(',')}`,
    {
      method: 'DELETE'
    }
  )
}
